import { useCallback, useEffect, useState } from "react";
const STORAGE_KEY = "erp_sidebar_collapsed";
function useSidebarCollapsed() {
  const [collapsed, setCollapsedState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? "true" : "false");
    } catch {}
  }, [collapsed]);
  const setCollapsed = useCallback((value) => {
    setCollapsedState(value);
  }, []);
  const toggleCollapsed = useCallback(() => {
    setCollapsedState((prev) => !prev);
  }, []);
  return { collapsed, setCollapsed, toggleCollapsed };
}
export { useSidebarCollapsed };
